/* build 20260721-2 — drawer truth sync after cart edits (v26). */
/* CarbonTree: endless scroll for collection pages (v2, 2026-07-14)
   + swatch sharpener (v3) + nav progress bar (v4, 2026-07-16)
   + menu-trigger resilience (v6)
   + cart badge sync (v7) + top-panel search (v11, 2026-07-20).
   TO REVERT: delete this file + its script tag in theme.liquid. */
(function () {
  'use strict';
  var DOTS_CSS =
    '.ct-inf-sentinel{min-height:1px}' +
    '.ct-inf-dots{display:flex;gap:8px;justify-content:center;padding:26px 0}' +
    '.ct-inf-dots span{width:8px;height:8px;border-radius:50%;background:#2A3B33;opacity:.25;animation:ctInfPulse 1s ease-in-out infinite}' +
    '.ct-inf-dots span:nth-child(2){animation-delay:.18s}' +
    '.ct-inf-dots span:nth-child(3){animation-delay:.36s}' +
    '@keyframes ctInfPulse{0%,100%{opacity:.25}50%{opacity:1}}';
  function nextUrl(scope) {
    var cur = scope.querySelector('.wt-pagination__item--current');
    var n = cur ? parseInt(cur.textContent, 10) : NaN;
    if (isNaN(n)) return null;
    var links = scope.querySelectorAll('a[href*="page="]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].href.match(/[?&]page=(\d+)/);
      if (m && parseInt(m[1], 10) === n + 1) return links[i].href;
    }
    return null;
  }
  function init() {
    var grid = document.querySelector('.collection__grid');
    var pag = document.querySelector('.wt-pagination');
    if (!grid || !pag) return;
    var style = document.createElement('style');
    style.textContent = DOTS_CSS;
    document.head.appendChild(style);
    var sentinel = document.createElement('div');
    sentinel.className = 'ct-inf-sentinel';
    var dots = document.createElement('div');
    dots.className = 'ct-inf-dots';
    dots.innerHTML = '<span></span><span></span><span></span>';
    dots.style.display = 'none';
    sentinel.appendChild(dots);
    pag.parentNode.insertBefore(sentinel, pag);
    pag.style.display = 'none';
    var url = nextUrl(pag);
    var prefetched = null;
    var busy = false;
    var done = !url;
    function prefetch() {
      if (url && !prefetched) {
        prefetched = fetch(url).then(function (r) { return r.text(); }).catch(function () { return null; });
      }
    }
    function fail() {
      done = true;
      sentinel.remove();
      pag.style.display = '';
      pag.style.visibility = 'visible';
      io.disconnect();
    }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || busy || done) return;
      busy = true;
      dots.style.display = 'flex';
      prefetch();
      prefetched.then(function (html) {
        prefetched = null;
        if (!html) { fail(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('.collection__grid > *');
        if (!items.length) { fail(); return; }
        for (var i = 0; i < items.length; i++) {
          grid.appendChild(document.importNode(items[i], true));
        }
        var newPag = doc.querySelector('.wt-pagination');
        url = newPag ? nextUrl(newPag) : null;
        dots.style.display = 'none';
        busy = false;
        if (!url) {
          done = true;
          sentinel.remove();
          io.disconnect();
        } else {
          prefetch();
        }
      });
    }, { rootMargin: '1600px 0px' });
    io.observe(sentinel);
    prefetch();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Swatch sharpener (2026-07-14): re-request 120px swatch PNGs at
   360px — pin-sharp on retina; covers late-inserted swatches too. */
(function () {
  'use strict';
  function sharpen(root) {
    var els = (root || document).querySelectorAll('.f-swatch__list__link__content');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var bg = el.style.backgroundImage || '';
      if (!bg) {
        try { bg = getComputedStyle(el).backgroundImage || ''; } catch (e) { bg = ''; }
      }
      if (bg.indexOf('width=120') !== -1) {
        el.style.backgroundImage = bg.replace(/width=120/g, 'width=360');
      }
    }
  }
  function start() {
    sharpen(document);
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1) sharpen(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Nav progress bar (2026-07-16): thin clay line during navigation.
   Styles in ticker-static.css (.ct-nav-progress). */
(function () {
  'use strict';
  function boot() {
    var bar = document.createElement('div');
    bar.className = 'ct-nav-progress';
    document.body.appendChild(bar);
    window.addEventListener('beforeunload', function () {
      bar.classList.add('is-active');
    });
    window.addEventListener('pageshow', function () {
      bar.classList.remove('is-active');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Menu-trigger resilience (v6, 2026-07-20): drawer triggers
   (hamburger, parent rows, close, overlay) are NEVER real navigation
   links, so when the theme's own listener hasn't already handled the
   click, ALWAYS stop the default first — a Kwikpass header re-render
   used to leave triggers with dead listeners whose hrefs then
   navigated, which read as "the page reloads the second I tap the
   nav". Then drive the drawer, with errors contained so a stale
   internal reference can never break the tap. */
(function () {
  'use strict';
  var TRIGGERS = [
    '.wt-header__menu-trigger',
    '.wt-header__nav-teaser__link--parent',
    '.wt-drawer__close',
    '.menu-drawer-overlay',
  ].join(', ');
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest(TRIGGERS) : null;
    if (!trigger || e.defaultPrevented) return;
    e.preventDefault();
    var drawer = document.querySelector('drawer-nav');
    if (!drawer || typeof drawer.toggleMenu !== 'function') return;
    try {
      drawer.toggleMenu({
        preventDefault: function () {},
        currentTarget: trigger,
      });
      if (typeof drawer.toggleThirdOptionMenu === 'function') {
        drawer.toggleThirdOptionMenu();
      }
    } catch (err) {}
  });
})();

/* Cart badge sync (v7) + drawer truth sync (v8, 2026-07-21): any
   cart-mutating fetch/XHR from any script re-renders the badge; and
   after a change/remove/clear, if the drawer is open, it re-fetches
   its true contents — third-party fetch wrappers sometimes strip the
   section HTML from the response, which left deleted items still
   showing in the drawer. */
(function () {
  'use strict';
  var scheduled = false;
  var drawerT = null;
  function refreshDrawerIfOpen() {
    if (!document.body.classList.contains('page-overlay-cart-on')) return;
    clearTimeout(drawerT);
    drawerT = setTimeout(function () {
      document.dispatchEvent(new Event('cart-drawer:refresh'));
    }, 700);
  }
  function isCartEdit(url) {
    return typeof url === 'string' && /\/cart\/(change|update|clear)/.test(url);
  }
  function refreshBadge() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      fetch('/?sections=cart-icon-bubble')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (s) {
          var el = document.getElementById('cart-icon-bubble');
          if (!el || !s || !s['cart-icon-bubble']) return;
          var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
          var wrap = doc.querySelector('.shopify-section');
          if (wrap) el.innerHTML = wrap.innerHTML;
        })
        .catch(function () {});
    }, 900);
  }
  function isCartMutation(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
  }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (isCartMutation(url)) {
      p.then(refreshBadge, function () {});
      if (isCartEdit(url)) p.then(refreshDrawerIfOpen, function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) {
      this.addEventListener('loadend', refreshBadge);
      if (isCartEdit(url)) this.addEventListener('loadend', refreshDrawerIfOpen);
    }
    return origOpen.apply(this, arguments);
  };
})();

/* Header search (v11, 2026-07-20): the magnifier next to the
   hamburger now opens the theme's own top-panel search (its form is
   products-only and its suggestions are products) instead of
   navigating to the /search page. Falls back to the products-only
   search page if the component is missing. Mobile overlay styling
   lives in ct-polish-2.css §23. */
(function () {
  'use strict';
  function boot() {
    if (document.querySelector('.ct-header-search')) return;
    var hams = [].slice.call(document.querySelectorAll('.wt-header__menu-trigger'));
    var ham = hams.filter(function (h) { return h.offsetParent; })[0] || hams[0];
    if (!ham || !ham.parentElement) return;
    var a = document.createElement('a');
    a.className = 'ct-header-search';
    a.href = '/search?type=product';
    a.setAttribute('aria-label', 'Search');
    a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg>';
    ham.insertAdjacentElement('afterend', a);
  }
  /* Document-level delegation so the handler survives third-party
     header re-renders (Kwikpass). */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('.ct-header-search') : null;
    if (!a || e.defaultPrevented) return;
    var sd = document.querySelector('search-drawer');
    var trig = sd && sd.querySelector('.wt-header__search-trigger');
    if (!trig) return;
    e.preventDefault();
    trig.click();
    setTimeout(function () {
      var input = sd.querySelector('input[name="q"]');
      if (input && sd.classList.contains('wt-drawer-search--active')) {
        input.focus();
      }
    }, 120);
  });
  /* The search results page's own form has no type filter — pin every
     /search form to products so no entry point surfaces pages or
     articles. */
  function pinForms() {
    var forms = [].slice.call(document.querySelectorAll('form[action$="/search"]'));
    forms.forEach(function (f) {
      if (f.querySelector('input[name="type"]')) return;
      var t = document.createElement('input');
      t.type = 'hidden';
      t.name = 'type';
      t.value = 'product';
      f.appendChild(t);
    });
  }
  function start() { boot(); pinForms(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Quick-add size sheet scroll cue (v12, 2026-07-20): when the open
   sheet's chip list overflows its card, flag it so CSS shows a
   bouncing arrow; clear the flag once the shopper reaches the end.
   Styles in ct-polish-2.css §22b. */
(function () {
  'use strict';
  function arm(wrapper) {
    var v = wrapper.querySelector('.size-variants');
    if (!v) return;
    var update = function () {
      var scrollable = v.scrollHeight > v.clientHeight + 6;
      wrapper.classList.toggle('ct-can-scroll', scrollable);
      var atEnd = v.scrollTop + v.clientHeight >= v.scrollHeight - 10;
      wrapper.classList.toggle('ct-at-end', atEnd);
    };
    if (!v.ctArmed) {
      v.ctArmed = true;
      v.addEventListener('scroll', update, { passive: true });
    }
    setTimeout(update, 60);
    setTimeout(update, 400);
  }
  document.addEventListener('click', function () {
    setTimeout(function () {
      var open = document.querySelectorAll('.size-selector-wrapper:not(.hidden)');
      for (var i = 0; i < open.length; i++) arm(open[i]);
    }, 120);
  }, true);
})();

/* Duplicate-add shield (v13, 2026-07-20): quick-add intermittently
   fired the same /cart/add request twice (stacked listeners in older
   cached scripts, double-taps). Regardless of the source, an
   IDENTICAL add fired within 1.5s of the previous one is swallowed
   with a benign 200 so the cart can never get a phantom duplicate.
   Different items, or the same item after 1.5s, pass through
   untouched. */
(function () {
  'use strict';
  var last = { sig: '', t: 0 };
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add') !== -1) {
      var body = init && typeof init.body === 'string' ? init.body : '';
      if (body) {
        var sig = url + '|' + body;
        var now = Date.now();
        if (sig === last.sig && now - last.t < 1500) {
          return Promise.resolve(new Response('{"items":[]}', {
            status: 200,
            headers: { 'Content-Type': 'application/json' }
          }));
        }
        last.sig = sig;
        last.t = now;
      }
    }
    return origFetch.apply(this, arguments);
  };
})();
